import { Box, Hidden, Icon, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    flexWrap: "wrap",
    alignItems: "center",
    minHeight: 56,
  },
}));

export const AppointmentDateItem = ({ date, name }) => {
  const { isToday, dateTime } = date;

  return (
    <div>
      <Typography variant="caption" className={isToday && "font-bold"}>Date: {dateTime}</Typography>
      {name && <Typography variant="caption" className="ml-8">{name}</Typography>}
    </div>
  );
};

export const AppointmentListItemContent = ({
  icon,
  title,
  status,
  dateAndBy,
  appointmentType,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.contentContainer}>
      {/* icon */}
      {icon && (
        <Hidden xsDown>
          <Icon className="mr-24">{icon}</Icon>
        </Hidden>
      )}
      {/* content */}
      <Box className="flex-row-container flex-auto justify-between">
        <Box>
          <Typography className="font-bold">{title}</Typography>
          <Typography variant="caption">Status: {status}</Typography>
          <Typography variant="caption">{dateAndBy}</Typography>
          <Typography variant="caption">Appointment Type: {appointmentType}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
